import React, { Component } from 'react';
import { Form, Input, Tabs, message, Select, DatePicker, Button, Radio,Modal,Cascader,Checkbox,Col,Tooltip,Icon } from 'antd';
import axios from 'axios';
import API from '../../../../../API/api';
import moment from 'moment';
import TreeControl from './TreeControl'
import { ASSIST, KNOWLEDGEWITHISSUE } from '../../../../../utils/questionManageType';

const { RangePicker } = DatePicker;
const FormItem = Form.Item;
const TabPane = Tabs.TabPane;
const Option = Select.Option;

class CreateTask extends Component{
    state = {
        tab:'1',
        loading: false,
        section:false,
        assistList:[],
        knowledgeTreeList:[],
        knowledgeTreeListFetching:false,
        assistTreeList:[],
        assistTreeListFetching:false,

        all_ord:true,
        skip_evaluation:false,
        skip_evaluation_task:true,
        limit_calculation:true,
        is_test:false,

        // skip_choice:true,
    }
    onTabChange = (key) => {
        this.setState({tab:key})
    }

    handleAssistChange = (value) => {
        let rootId = value[value.length - 1];
        this.setState({assist:rootId,section:false})
        this.handleGetTreeList(rootId,ASSIST,'assistTreeList')
    }
    handleSkip = (val, type) => {
        this.setState({[type]:val.target.checked})
    }
    handleTreeSelect=(selectedKeys,type)=>{
        this.setState({section:selectedKeys[0]||false})
    }
    handleGetTreeList = (rootId, relate_type,list) => {
        this.setState({knowledgeTreeListFetching:true});
        axios.post(API.GET_TREE_LIST,{ type: relate_type, rootId }).then((res)=>{
            res = res.data
            if (res.code === 0) {
                this.setState({[list]:res.data.list,knowledgeTreeListFetching:false});
            }else{
                message.error(res.message);
            }
        },(error)=>{
            message.error('网络错误！');
        });
    }
    onOk = () => {
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {


                let data = {};
                data.name = values.name;
                data.source_id = this.state.section;
                if(this.state.tab == 1){
                    if(!this.state.section)
                    {
                        data.source_type=11;
                        data.source_id=this.state.assist;
                    }
                    else{
                        data.source_type=1;
                    }
                }else{
                    data.source_type=26;
                }
                if(!data.source_id){return message.error('请选择教辅或知识点')}

                data.skip_evaluation = ~~this.state.skip_evaluation;
                data.skip_evaluation_task = ~~this.state.skip_evaluation_task;
                data.limit_calculation = ~~this.state.limit_calculation;
                data.is_test = ~~this.state.is_test;
                data.all_ord = ~~this.state.all_ord;
                // data.skip_choice = ~~this.state.skip_choice;

                if(this.props.taskId){
                    data.task_id = this.props.taskId
                }
                this.setState({disabled:true})

                axios.post(API.EVALUATION_TASK_ADD,data).then((res)=>{
                    res = res.data
                    if (res.code === 0) {
                        message.success('任务创建成功');
                        this.setState({ loading: false, visible:false,disabled:false});
                        this.props.refresh();
                        this.props.onCancel();
                    }else{
                        message.error(res.message);
                        this.setState({ loading: false,disabled:false});
                    }
                },(error)=>{
                    message.error('网络错误！');
                });
            }


        });
    }
    componentDidMount(){
        axios.post(API.GET_NO_SUBJECT_ASSIST_LIST).then((res)=>{
            res = res.data
            if (res.code === 0) {
                this.setState({assistList:res.data.list});
            }else{
                message.error(res.message);
            }
        },(error)=>{
            message.error('网络错误！');
        });
        this.handleGetTreeList(0,KNOWLEDGEWITHISSUE,'knowledgeTreeList')
    }

    disabledStartDate = (startValue) => {
        const endValue = moment(this.state.end_time);
        if (!startValue || !endValue) {
            return false;
        }
        return startValue.valueOf() > endValue.valueOf();
    }

    disabledEndDate = (endValue) => {
        const startValue = moment(this.state.start_time);
        if (!endValue || !startValue) {
            return false;
        }
        return endValue.valueOf() <= startValue.valueOf();
    }
    render(){
        const {visible } = this.props;
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: {
                xs: { span: 12 },
                sm: { span: 5 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 14 },
            },
        };
        const loop = data => data.map(item => {
            let option = { value: item.assist_id || item.book_id || item.edition_id, label: item.name }
            if (item.list) option.children = loop(item.list)
            return option;
        })
        return(
                <Modal
                    visible={visible}
                    title={this.props.taskId?"修改任务":"新建任务"}
                    onOk={this.onOk}
                    onCancel={this.props.onCancel}
                    footer={[
                        <Button disabled={this.state.disabled} key="back" size="large" onClick={this.props.onCancel}>取消</Button>,
                        <Button disabled={this.state.disabled} key="submit" type="primary" size="large" loading={this.state.loading} onClick={this.onOk}>
                            {this.props.taskId?"修改任务":"创建任务"}
                        </Button>,
                    ]}
                >
                    <Form>
                        <FormItem
                            {...formItemLayout}
                            label="任务名称"
                            hasFeedback
                            style={{marginBottom:10,marginRight:10,}}
                        >
                            {getFieldDecorator('name', {
                                initialValue:this.state.name,
                                rules: [{
                                    type: 'string', message: '请输入正确的任务名称',
                                }, {
                                    required: true, message: '请输入任务名称',
                                }],
                            })(
                                <Input />
                            )}
                        </FormItem>





                        <FormItem style={{marginBottom:10,marginRight:10,}} hasFeedback{...formItemLayout}
                                  label="">
                            <Checkbox style={{marginLeft:20}} checked = { this.state.skip_evaluation_task } onChange = { (val)=>{this.handleSkip(val,'skip_evaluation_task')} }>跳过已有评测&精题任务的题目</Checkbox>

                        </FormItem>
                        <FormItem style={{marginBottom:10,marginRight:10,}} hasFeedback{...formItemLayout}
                                  label="">
                            <Checkbox style={{marginLeft:20}} checked = { this.state.skip_evaluation } onChange = { (val)=>{this.handleSkip(val,'skip_evaluation')} }>跳过已有评测题标签的题目</Checkbox>

                        </FormItem>
                        <FormItem style={{marginBottom:10,marginRight:10,}} hasFeedback{...formItemLayout}
                                  label="">
                            <Checkbox style={{marginLeft:20}} checked = { this.state.limit_calculation } onChange = { (val)=>{this.handleSkip(val,'limit_calculation')} }>计算题每节抽取20道</Checkbox>
                            <Tooltip
                                title={<div>
                                    <div>
                                        计算题选取规则：
                                        <div>
                                            1.只含有竖式(脱式)知识点的节，每个知识点均等选取，共抽取20道竖式(二期), 脱式(二期)的题目；
                                        </div>
                                        <div>
                                            2.竖式和脱式知识点都包含的节，每个知识点均等选取，共抽取10道竖式(二期)和10道脱式(二期)题目；
                                        </div>
                                        <div>
                                            3.若抽取20/10道题出现每个知识点题目不均等情况，则抽取总题数向上增加直到每个知识点可以均等抽取题目；
                                        </div>

                                    </div>
                                </div>

                                }
                                mouseEnterDelay={0.5}>
                                <Icon type="question-circle-o" style={{marginLeft:20,color:'#1890ff',cursor: 'help'}} />
                            </Tooltip>

                        </FormItem>
                        <FormItem style={{marginBottom:10,marginRight:10,}} hasFeedback{...formItemLayout}
                                  label="">
                            <Checkbox style={{marginLeft:20}} checked = { this.state.all_ord } onChange = { (val)=>{this.handleSkip(val,'all_ord')} }>将任务中的所有题刷为普通题</Checkbox>

                        </FormItem>
                        <FormItem style={{marginBottom:10,marginRight:10,}} hasFeedback{...formItemLayout}
                                  label="">
                            <Checkbox style={{marginLeft:20}} checked = { this.state.is_test } onChange = { (val)=>{this.handleSkip(val,'is_test')} }>创建任务为测试任务，可删除</Checkbox>

                        </FormItem>

                        <div style={{paddingLeft:20}}>
                            <Tabs defaultActiveKey= { `1` } onChange={ this.onTabChange }>
                                <TabPane tab="章节" key = { `1` }>
                                    <Cascader  popupPlacement="topLeft" allowClear={ false } style={ {width:"60%"} } options={ loop(this.state.assistList) ? loop(this.state.assistList) : [] } onChange={ this.handleAssistChange } placeholder="Please select" />
                                    <TreeControl
                                        treeData={ this.state.assistTreeList }
                                        key = { ASSIST }
                                        loading= { this.state.assistTreeListFetching }
                                        handleTreeSelect = { selectedKeys => this.handleTreeSelect(selectedKeys, ASSIST) }
                                        checkable= { false }
                                        checkStrictly = { false }
                                    />
                                </TabPane>

                            </Tabs>
                        </div>
                    </Form>
                </Modal>
        );
    }

}
const WrappedCreateTaskForm = Form.create()(CreateTask);
export default WrappedCreateTaskForm


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/question_evaluating/evaluating_task_list/creat_task/view.js